import { ArticleListRequestParams } from '../../core/models/interfaces/article-list-request-params.interface';

export const mapUiParamsToApiParams = (uiParams: ArticleListRequestParams) => {
    const apiParams: any = {
        title: uiParams.title,
        sortBy: uiParams.sortBy,
        sortOrder: uiParams.sortOrder
    };

    if (uiParams.visibility === 'visible') {
        apiParams.visibility = true;
    } else if (uiParams.visibility === 'hidden') {
        apiParams.visibility = false;
    } else if (uiParams.visibility === 'all') {
        delete apiParams.visibility;
    }

    return apiParams;
};
